// Save a PDF blob using the File System Access API where supported (Chrome/Edge
// desktop), with a transparent anchor-tag download fallback everywhere else.
//
// Usage: await savePdf(blob, "invoice_AB-25-09-01.pdf");
import { toast } from "sonner";

export async function savePdf(blob, suggestedName) {
  const url = URL.createObjectURL(blob);
  try {
    if (typeof window !== "undefined" && "showSaveFilePicker" in window) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName,
          types: [{ description: "PDF", accept: { "application/pdf": [".pdf"] } }],
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        toast.success(`Saved ${suggestedName}`);
        return true;
      } catch (err) {
        // User cancelled the picker — silently abort.
        if (err && err.name === "AbortError") return false;
        // Any other error: fall through to anchor-tag download.
        // eslint-disable-next-line no-console
        console.warn("File System Access API failed, falling back:", err);
      }
    }
    // Fallback: classic anchor-tag download (mobile, Firefox, Safari).
    const a = document.createElement("a");
    a.href = url;
    a.download = suggestedName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    return true;
  } finally {
    URL.revokeObjectURL(url);
  }
}
